import { useContext } from 'react';
import { AppContext, REMEMBER_ME_TOKEN } from '../App';

const BASE = "/api";
const OPEN = BASE + "/open"

const TOKEN_HEADER = "X-Jumbletree-Learn-Token";
const TOKEN_STORAGE = "jumbletree.learn.token";

const handleResponse = resp=>{
	//Even though most open calls won't set a token, we still want to grab one if it's there
	const authToken = resp.headers.get(TOKEN_HEADER);
	if (authToken)
		sessionStorage.setItem(TOKEN_STORAGE, authToken);

	return resp.json()	
}

const postOpen = (url, data) => {
	const options = {
		headers: {"Content-Type": "application/json; charset=utf-8"},
		method: "post",
		body: JSON.stringify(data)
	};

	return fetch(OPEN + url, options).then(handleResponse);
}

const get = (url) => {
	const headers = {
		"Content-Type": "application/json; charset=utf-8",
		"Authorization": "Bearer " + sessionStorage.getItem(TOKEN_STORAGE)
	}
	const options = {
		headers,
		method: "get"
	}

	return fetch(BASE + url, options).then(handleResponse);
}
const post = (url, data) => {
	const headers = {
		"Content-Type": "application/json; charset=utf-8",
		"Authorization": "Bearer " + sessionStorage.getItem(TOKEN_STORAGE)
	}
	const options = {
		headers,
		method: "post",
		body: JSON.stringify(data)
	}

	return fetch(BASE + url, options).then(handleResponse);
}

const useRemote = () => {

	const app = useContext(AppContext);

	return {
		checkRememberMeToken: token => {
			return postOpen("/token-check", {token});
		},
		checkEmailForLogin: email => {
			return postOpen("/email-check", {email});
		},
		send2FA: email => {
			return postOpen("/send-2fa", {email});
		},
		verify2FA: (email, expectedCode, enteredCode) => {
			return postOpen("/verify-2fa", {email, expectedCode, enteredCode});
		},
		createAccount: (data)=> {
			postOpen("/create-account", data).then(response=>{
				app.setSchool(response.school);
				//Linked to the code, so cannot be faked
				app.setUser(data.email);
				app.setAuthenticated(true);
				app.setFirstLogin(true);
			});
		},
		login: (data)=> {
			postOpen("/login", data).then(response=>{
				app.setSchool(response.school);
				//Linked to the code, so cannot be faked
				app.setUser(data.email);
				app.setAuthenticated(true);
				app.setFirstLogin(true);
			});
		},
		//Non-open functions
		getRefreshToken: ()=>{
			return get("/refresh-token").then(response=>{
				localStorage.setItem(REMEMBER_ME_TOKEN, response.token);
			});
		},
		logout: ()=>{
			localStorage.removeItem(REMEMBER_ME_TOKEN);
			sessionStorage.removeItem(TOKEN_STORAGE);
			app.setAuthenticated(false);
			app.setSchool(null);
			app.setUser(null);
		},
		getPDF: data=>{
			const headers = {
				"Content-Type": "application/x-octet-stream",
				"Authorization": "Bearer " + sessionStorage.getItem(TOKEN_STORAGE)
			}
			const options = {
				headers,
				method: "post",
				body: data
			}
		
			return fetch(BASE + "/generate-maths", options).then(resp=>{
				//Update the auth token while we're here
				const authToken = resp.headers.get(TOKEN_HEADER);
				if (authToken)
					sessionStorage.setItem(TOKEN_STORAGE, authToken);
			
				return resp.arrayBuffer();
			});
		},
		refreshSchool: ()=>{
			return get("/school/" + app.school.id).then(app.setSchool);
		},
		requestInvoice: data=>{
			return post("/generate-invoice", data);
		}
	}
}

export default useRemote;